import { gql } from "@apollo/client";

export const GET_FIGURA_PROFESIONAL_BY_ID_PLAN_CUIDADO = gql`
  query getFiguraProfesionalByIdPlanCuidado(
    $idPlanCuidado: Int!
    $idTipoProfesional: Int!
    $idEvaluacion: Int!
  ) {
    figuraProfesionalByIdPlanCuidado(
      idPlanCuidado: $idPlanCuidado
      idTipoProfesional: $idTipoProfesional
      idEvaluacion: $idEvaluacion
    ) {
      idFiguraProfesional
      descripcion
    }
  }
`;